import { Urls } from "../constants"

export const Footer = () => {

    return (
        <div className="Footer">
            <a target="_blank" href={Urls.MARKETING_AI_SHOWCASE_TERMS}>Terms of Use</a> - <a target="_blank" href={Urls.MARKETING_AI_SHOWCASE_PRIVACY_POLICY}>Privacy Policy</a>
        </div>
    )
}